import { MainAction } from './models'

export const pushToken: MainAction<[string?]> =
  key =>
  (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      api.post('/user-devices', { push_token: key })
    } catch (err) {
      // Handle Err
    }
  }
